import { CoreResource } from "../../core/index.js";
import * as PIM from "../pim-vocabulary.js";
/**
 * Represents a schema, diagram, on PIM level. Schema on this level
 * must contains a reference to all it's parts: classes, associations,
 * and attributes.
 */
export class PimSchema extends CoreResource {
    static TYPE = PIM.SCHEMA;
    /**
     * Label used in human readable documents as a name for this resource.
     */
    pimHumanLabel = null;
    /**
     * Description, longer plain text, shown in human readable documents
     * as a description for this resource.
     */
    pimHumanDescription = null;
    pimParts = [];
    constructor(iri = null) {
        super(iri);
        this.types.push(PimSchema.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(PimSchema.TYPE);
    }
}
//# sourceMappingURL=pim-schema.js.map